import { __ } from '../Txlat';
import { getUrl } from '../utility';
import { app } from 'apprun';

export default function ({ agency }) {
  if (!agency) { return; }

  return (
    <div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="agent-profile-top-wrap">
            <div class="agent-profile-header" style="white-space: normal;">
              <h1>{agency.name}</h1>
            </div>
            <p class="agent-list-position">
              {agency.address}<br />
              {`${agency.city} ${agency.province} ${agency.postal_code}`}<br />
              {(agency.phone && agency.phone !== '') ? <div><strong>{__('Tel')}:</strong>&nbsp;<a href={'tel:' + agency.phone}><span class="agent-phone ">{agency.phone}</span></a><br /></div> : ''}
              {(agency.website && agency.website !== '') ? <div><strong>{__('Website')}:</strong>&nbsp;<a href={getUrl(agency.website)} target='_blank' style={'overflow-wrap: break-word;'} >{agency.website}</a><br /></div> : ''}
            </p>
          </div>

          <div class="agent-profile-buttons">
            <a href={'mailto:' + agency.email} class="btn btn-search btn-secondary" style='color:white'>
              {__('Send Email')}
            </a>

            <a href={'tel:' + agency.phone} class="btn btn-secondary">
              <span class="hide-on-click">{__('Call')}</span>
              <span class="show-on-click">{agency.phone}</span>
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}
